import { render, staticRenderFns } from "./ProductPurchased.vue?vue&type=template&id=14f71335&scoped=true"
import script from "./ProductPurchased.vue?vue&type=script&lang=js"
export * from "./ProductPurchased.vue?vue&type=script&lang=js"
import style0 from "./ProductPurchased.vue?vue&type=style&index=0&id=14f71335&prod&lang=scss&scoped=true"
import style1 from "./ProductPurchased.vue?vue&type=style&index=1&id=14f71335&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f71335",
  null
  
)

export default component.exports